export default {"src":"/_next/static/media/weather-station.4926a922.svg","height":41,"width":30,"blurWidth":0,"blurHeight":0};